import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { cn } from "@/lib/utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TableRow',
    props: {
        class: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tr", {
                class: _normalizeClass(_unref(cn)('data-[state=selected]:tw-bg-muted', props.class))
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 2));
        };
    }
});
